<template>
  <div class="t-signup-service-ended">
    <div class="t-signup-service-ended__content">
      <div class="t-signup-service-ended__content-logo">
        <img src="@/images/cotoha-call-center-logo-horizontal.svg" height="100" />
      </div>
      <div class="t-signup-service-ended__content-text">
        <h3>
          COTOHA Call Centerは、新規お申し込みの受付を終了させていただきました。<br />サービスに関わる情報は<a
            href="https://www.ntt.com/business/services/voice-visual-communication/callcenter-ivr/ccaas.html"
            >こちら</a
          >を参照ください。
        </h3>
      </div>
      <div class="t-signup-service-ended__content-graphic">
        <img src="@/images/pages/login-graphic.svg" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 't-signup-service-ended',
};
</script>
